import { render, staticRenderFns } from "./resources-manage.vue?vue&type=template&id=361d359c&scoped=true&"
import script from "./resources-manage.vue?vue&type=script&lang=js&"
export * from "./resources-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361d359c",
  null
  
)

export default component.exports